import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { css } from 'linaria';
import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { Button } from 'evergreen-ui';
import surprise from 'src/assets/surprise.png';
import menu from 'src/assets/menu.png';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { drawer } from 'src/store/drawer.store';

const HeaderContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 16px;
`;
const Left = styled.div`
	flex: 1;
`;
const Surprise = styled.div`
	flex: 1;
	display: flex;
	justify-content: flex-end;

	img {
		max-width: 50px;
		max-height: 50px;
	}
`;
const Title = styled.h3`
	color: white;
	font-size: 18px;
    font-weight: 100;
`;
const menuButton = css`
	padding-left: 0 !important;

	@media (min-width: 891px) {
		display: none !important;
	}
`;

type HeaderProps = {
	title?: string;
}

export const Header: FC<HeaderProps> = (props) => {
	const { title } = props;

	return (
		<HeaderContainer>
			<Left>
				<Button
					onClick={() => drawer.open()}
					appearance={'minimal'}
					className={menuButton}
				>
					<img src={menu} width="50px" alt=""/>
				</Button>
			</Left>
			<Title>{title}</Title>
			<Surprise>
				<img src={surprise} alt=""/>
			</Surprise>
		</HeaderContainer>
	);
};
